<template>
  <section v-if="site" :class="{'overflow-hidden': !logged}">

    <navigation/>

    <slot/>

    <auth-reconnect v-if="!logged" />

  </section>
</template>

<script>

import navigation from '@/components/navigation/TopMenu.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'layout-base',

  components: { navigation },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite'
    }),
    ...mapGetters('user', {
      logged: 'isLoggedIn'
    })
  }
}

</script>



// WEBPACK FOOTER //
// src/components/layouts/default-layout.vue